'use strict'

module.exports = {
  ASYNC_RESOURCE: 'async_resource',
  ASYNC_LOCAL_STORAGE: 'async_local_storage',
  ASYNC_HOOKS: 'async_hooks',
  NOOP: 'noop'
}
